import * as actionTypes from './actionTypes';

const initialState = {
  bidPreferenceClasses: {},
  error: { preferenceError: false, message: '' },
  status: {},
  pairingdate: {},
  selectedCombinedPreferences: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BID_PREFERENCE_CLASSES_REQUEST:
      return { ...state, bidPreferenceClasses: {}, status: {} };
    case actionTypes.FETCH_BID_PREFERENCE_CLASSES_SUCCESS:
      return { ...state, bidPreferenceClasses: action.bidPreferenceClasses, status: {} };
    case actionTypes.FETCH_BID_PREFERENCE_CLASSES_FAILURE:
      return { ...state, error: { preferenceError: true, messages: action.messages } };
    case actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_REQUEST:
      return {
        ...state,
        status: {},
        bidPreferenceClasses: {
          ...state.bidPreferenceClasses,
          classOptionAttributes: {}
        }
      };
    case actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_SUCCESS:
      if(action.openCombinedPreferences){
        return {
          ...state,
          status: {},
          bidPreferenceClasses: {
            ...state.bidPreferenceClasses,
            classOptionAttributes: action.classOptionAttributes
          },
          selectedCombinedPreferences: action.classOptionAttributes
        }
      }
      else return {
        ...state,
        status: {},
        bidPreferenceClasses: {
          ...state.bidPreferenceClasses,
          classOptionAttributes: action.classOptionAttributes
        },
        selectedCombinedPreferences: {}
      };
    case actionTypes.FETCH_PAIRING_DATE_SUCCESS:
      return { ...state, pairingdate: action, isFetching: false };
    case actionTypes.FETCH_PAIRING_DATE_FAILURE:
      return { ...state, error: { activity: true, messages: action.messages }, isFetching: false };
    default:
      return state;
  }
};

export { reducer as default };
